/** @format */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Table, TableBody, TableCell, TableFooter, TableHead, TableRow, withStyles } from '@material-ui/core';
import adescomStyle from '../../../assets/jss/adescom/adescomStyle';
import RemoveButton from '../../../components/Buttons/RemoveButton';
import TableHeaderContentCell from '../../../components/Table/TableHeaderContentCell';
import CustomTextButtom from '../../../components/Buttons/CustomTextButton';
import oplAppStyle from '../../../assets/themes/OPL/jss/App/OplAppStyle';

interface BillingSelectedSimCardListProps {
    classes: any;
    selectedNumbers: Array<string>;
    removeNumberCallback: (params: string) => void;
    clearNumbersCallback: () => void;
    searchBillingCallback: () => void;
}

export const BillingSelectedSimCardList = (props: BillingSelectedSimCardListProps): React.ReactElement => {
    const classes = props.classes;
    const tableControlStickyHeader = { root: classes.tableControlStickyHeader };
    const tableCellRoot = { root: classes.tableCellRoot };
    const tableRootNotMinWidth = { root: classes.tableRootNotMinWidth };
    const tableStickyCommand = { root: classes.tableStickyCommand };

    return (
        <Table classes={tableRootNotMinWidth}>
            <TableHead>
                <TableRow>
                    <TableCell classes={tableControlStickyHeader} colSpan={3} align="left" padding="none">
                        {props.selectedNumbers.length > 0 && (
                            <CustomTextButtom
                                size={'lg'}
                                callback={props.clearNumbersCallback}
                                callbackParam={{}}
                                color="primary"
                                label="general:common.clear"
                            />
                        )}
                        {props.selectedNumbers.length > 0 && (
                            <CustomTextButtom
                                size={'lg'}
                                callback={props.searchBillingCallback}
                                callbackParam={{}}
                                color="primary"
                                label="general:common.search"
                            />
                        )}
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell classes={tableStickyCommand} align="left" padding="none">
                        <TableHeaderContentCell textAlign="left" title="general:common.commands" showSort={false} onlyFilter={false} />
                    </TableCell>
                    <TableCell classes={tableControlStickyHeader} align="left" padding="none">
                        <TableHeaderContentCell
                            textAlign="left"
                            title="pools:pool.selected_msidns"
                            fieldName="msisdn"
                            showSort={false}
                            onlyFilter={false}
                            defaultDirection="desc"
                            searchFieldType="number"
                        />
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {props.selectedNumbers &&
                    props.selectedNumbers.map((el: string) => {
                        return (
                            <TableRow key={el}>
                                <TableCell classes={tableCellRoot} align={'left'}>
                                    <RemoveButton callback={props.removeNumberCallback} callbackParam={{ number: el }} />
                                </TableCell>
                                <TableCell classes={tableCellRoot} align={'left'}>
                                    {el}
                                </TableCell>
                            </TableRow>
                        );
                    })}
            </TableBody>
            <TableFooter></TableFooter>
        </Table>
    );
};

export default withStyles(oplAppStyle)(BillingSelectedSimCardList);
